// Week 33 Word Power (8 Collocation Cards)
export default [
  { id: 1, word: "run in the corridor", definition_en: "to move fast down a hallway", definition_vi: "chạy trong hành lang" },
  { id: 2, word: "have an accident", definition_en: "to suffer an unexpected injury", definition_vi: "gặp tai nạn" },
  { id: 3, word: "fall down", definition_en: "to drop to the ground suddenly", definition_vi: "ngã xuống" },
  { id: 4, word: "hurt yourself", definition_en: "to cause injury to your body", definition_vi: "tự làm mình bị thương" },
  { id: 5, word: "feel terrible", definition_en: "to feel very unwell or sad", definition_vi: "cảm thấy tồi tệ" },
  { id: 6, word: "tell the truth", definition_en: "to speak honestly about what happened", definition_vi: "nói sự thật" },
  { id: 7, word: "learn a lesson", definition_en: "to gain wisdom from an experience", definition_vi: "rút ra bài học" },
  { id: 8, word: "break something", definition_en: "to damage an object into pieces", definition_vi: "làm vỡ vật gì đó" }
];
